import { useEffect, useRef, useState } from "react";
import {
    AI1Image,
    AI2Image,
    AI3Image,
    AI4Image,
    AI5Image,
    AI6Image,
    AI7Image,
    AI8Image,
    AI9Image,
    AI10Image,
    AI11Image,
    GeneralMobile1,
    GeneralMobile2,
    AIPoweredMobile,
    InstantQuestion1,
    InstantQuestion2,
    Concept1,
    Concept2,
    Concept3,
    Concept4,
    Concept5,
    Concept6,
    Personalized1,
    Personalized2,
    Interactive1,
    Interactive2,
    MBVocabulary1,
    MBVocabulary2,
    ConnectingConcepts1,
    ConnectingConcepts2,
    Summarization1,
    Summarization2,
    ActiveRecall1,
    ActiveRecall2,
    AvailabilityMB,
} from "../assets/images/image";
import { useScrollToSection } from "../hooks/ScrollContext";
import { AnimatePresence, motion } from "framer-motion";
import AIMobileComponent from "../component/AIMobileComponent";

const images = [AI1Image, AI2Image, AI3Image, AI4Image, AI5Image, AI6Image, AI7Image, AI8Image, AI9Image, AI10Image, AI11Image];

const items = [
    {
        content: "AI-Powered Creation Stack of Flashcards",
        index: 1,
        isLeft: false,
    },
    {
        content: "Instant Question Answering",
        index: 2,
        isLeft: true,
    },
    {
        content: "Concept Clarification & Elaboration",
        index: 3,
        isLeft: false,
    },
    {
        content: "Personalized Study Guidance & Tips",
        index: 4,
        isLeft: true,
    },
    {
        content: "Interactive Quizzing & Practice",
        index: 5,
        isLeft: false,
    },
    {
        content: "Vocabulary & Definition Support",
        index: 6,
        isLeft: true,
    },
    {
        content: "Connecting Concepts",
        index: 7,
        isLeft: false,
    },
    {
        content: "Summarization of Complex Topics",
        index: 8,
        isLeft: true,
    },
    {
        content: "Active Recall Prompts",
        index: 9,
        isLeft: false,
    },
    {
        content: "24/7 Availability",
        index: 10,
        isLeft: true,
    },
];
const AI = () => {
    const targetRef: any = useRef(null);
    const { scrollToSection } = useScrollToSection();
    const [indexChoose, setIndexChoose] = useState(0);
    const [isClicked, setIsClicked] = useState(false);
    const [isFirstHighlight, setIsFirstHighlight] = useState(true);

    useEffect(() => {
        if (isClicked) return;

        const interval = setInterval(() => {
            setIndexChoose(prevIndex => {
                const newIndex = (prevIndex + 1) % items.length;
                if (isFirstHighlight) setIsFirstHighlight(false);
                return newIndex;
            });
        }, 5000);

        return () => clearInterval(interval);
    }, [isClicked, items.length, isFirstHighlight]);
    const handleItemClick = (index: number) => {
        setIndexChoose(index);
        setIsClicked(true);
        setIsFirstHighlight(false);
        if (window.matchMedia("(max-width: 767px)").matches && targetRef.current) {
            scrollToWithOffset(targetRef, 110);
        }
    };

    const scrollToWithOffset = (ref: any, offset = 100) => {
        if (!ref.current) return;
        const element = ref.current;
        const y = element.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    };
    return (
        <div className="w-full h-full">
            <>
                <div className="space-y-2 hidden md:block">
                    <p className="text-[48px] font-light text-[#484848] text-center font-inter" data-reveal="up">AI-Companion</p>
                    <p className="text-[24px] font-bold text-[#484848] text-center font-inter" data-reveal="up">Meet Your Dedicated AI Companion (Pro Feature)</p>
                </div>
                <div className=" items-start px-[100px] min-h-[620px] gap-x-[100px] mt-6 hidden md:flex">
                    <div className="w-[60%] min-h-[620px] relative" data-parallax="0.12">
                        {images.map((val: any, index: number) => {
                            return (
                                <div key={index} className={`w-full h-full  absolute duration-300 ${indexChoose === index ? "opacity-100 z-10" : "opacity-0 z-0"}`}>
                                    <img src={val} alt="" loading="lazy" className={`w-full h-full object-contain`} />
                                </div>
                            )
                        })}
                    </div>

                    <div className="w-[40%] space-y-10">
                        <div className="space-y-4 w-full" data-reveal="up">
                            <div className="flex items-center justify-end gap-x-2">
                                <div className="w-[17px] h-[17px] rounded-full bg-[#484848] flex items-center justify-center text-[14px] font-inter font-bold text-white">
                                    ?
                                </div>
                                <p className="text-[14px] font-inter font-light text-[#484848] ">Click to find out more.</p>
                            </div>
                            <div className="flex gap-4 w-full">
                                <div className="flex flex-1 flex-col items-end gap-4">
                                    <div
                                        className={`bg-[#D9D9D9] text-[14px] font-inter text-[#484848] h-[30px] flex items-center justify-center rounded-lg max-w-[400px] px-2 cursor-pointer w-fit ${indexChoose === 0 ? "bg-[#FFD600] font-bold" : "bg-[#D9D9D9] "}`}
                                        onClick={() => handleItemClick(0)}
                                    >
                                        General
                                    </div>
                                </div>

                                <div className="flex flex-col items-center gap-4 relative flex-shrink-0">
                                    <div className="w-[1.5px] bg-gray-300 h-[60px] absolute top-1/2 -translate-y-1/2" />
                                    <div className="h-[30px] flex items-center justify-center relative">
                                        <div
                                            onClick={() => handleItemClick(0)}
                                            className={`cursor-pointer rounded-full z-10 flex items-center justify-center duration-300 ${indexChoose === 0 ? "w-[17px] h-[17px] bg-[#FFD600]" : "w-3 h-3 bg-gray-300"}`}
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-1 flex-col items-start gap-4">
                                    <div className="h-[30px]" />
                                </div>
                            </div>
                            <p className="text-[17px] font-inter font-bold text-[#484848] w-full text-center ">What You Gain</p>
                        </div>
                        <div className="relative w-full" data-reveal="up">
                            <div className="absolute left-1/2 -translate-x-1/2 top-2 bottom-2 w-[1.5px] bg-gray-300" />
                            <div className="flex flex-col gap-4">
                                {items.map((item) => (
                                    <div key={item.index} className="flex items-stretch gap-4">
                                        <div className="flex flex-1 justify-end">
                                            {item.isLeft ? (
                                                <div
                                                    className={`text-[#484848] text-[14px] font-inter h-auto flex items-center justify-center rounded-lg max-w-[400px] px-2 py-1.5 cursor-pointer duration-300 text-center leading-snug break-words ${indexChoose === item.index ? "bg-[#FFD600] font-bold" : "bg-[#D9D9D9] "}`}
                                                    onClick={() => handleItemClick(item.index)}
                                                >
                                                    {item.content}
                                                </div>
                                            ) : (
                                                <div className="flex-1" />
                                            )}
                                        </div>
                                        <div className="flex items-center justify-center flex-shrink-0 w-6">
                                            <div
                                                className={`
                                                    cursor-pointer rounded-full z-10 flex items-center justify-center duration-300
                                                    ${indexChoose === item.index ? "w-[17px] h-[17px]" : "w-3 h-3"}
                                                    ${item.index === 1 && isFirstHighlight ? "animate-highlight-dot" : indexChoose === item.index ? "bg-[#FFD600]" : "bg-gray-300"}
                                                `}
                                                onClick={() => handleItemClick(item.index)}
                                            />
                                        </div>
                                        <div className="flex flex-1 justify-start">
                                            {!item.isLeft ? (
                                                <div
                                                    className={`text-[#484848] text-[14px] font-inter h-auto flex items-center justify-center rounded-lg max-w-[400px] px-2 py-1.5 cursor-pointer duration-300 text-center leading-snug break-words ${indexChoose === item.index ? "bg-[#FFD600] font-bold" : "bg-[#D9D9D9] "}`}
                                                    onClick={() => handleItemClick(item.index)}
                                                >
                                                    {item.content}
                                                </div>
                                            ) : (
                                                <div className="flex-1" />
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div >
                </div >
            </>

            <div className="flex flex-col items-center gap-y-10  pt-6 md:hidden">
                <div className="w-full flex items-start px-4">
                    <div className="flex items-center w-full">
                        <span
                            className="text-[17px] font-normal font-inter text-[#484848] cursor-pointer hover:underline bg-[#D9D9D9] me-6 pt-[4px] pb-[4px] ps-[8px] pe-[8px] rounded-[16px]"
                            onClick={() => scrollToSection("home")}
                        >
                            Home
                        </span>
                        <div className="bg-[#FFD600] me-6 pt-[4px] pb-[4px] ps-[8px] pe-[8px] rounded-[16px]">
                            <span className="text-[17px] font-normal font-inter text-[#484848] mx-2">→</span>
                            <span className="text-[17px] font-bold font-inter text-[#484848]">
                                AI-Companion
                            </span>
                        </div>
                    </div>
                </div>
                <div className="space-y-2">
                    <p className="text-[24px] font-light text-[#484848] text-center font-inter" data-reveal="up">AI-Companion</p>
                    <p className="text-[14px] font-bold text-[#484848] text-center font-inter" data-reveal="up">Meet Your Dedicated AI Companion (Pro Feature)</p>
                </div>
                <div id="scroll-target" className="bg-[#F5F6F6] py-3 text-center border-b border-gray-300 w-full sticky top-0 z-100">
                    <p className="text-[14px] font-semibold italic text-[#333] mb-5">
                        What You Gain
                        <span className="block text-[14px] font-normal italic text-[#7A7A7A]">
                            (Swipe & Tap to learn more) →
                        </span>
                    </p>

                    <div
                        className="flex space-x-2 overflow-x-auto pb-2 scrollbar-hide px-4"
                        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
                    >
                        {[{ index: 0, content: "General" }, ...items].map((item, idx) => (
                            <div key={idx}>
                                <span
                                    onClick={() => handleItemClick(idx)}
                                    className={`text-[12px] px-3 py-1 rounded-[8px] whitespace-nowrap cursor-pointer flex-shrink-0 transition-all duration-200
                                     ${indexChoose === idx
                                            ? 'bg-[#FFD600] text-[#333] font-bold'
                                            : 'bg-[#E5E5E5] text-[#333]'
                                        }`}
                                >
                                    {item.content}
                                </span>
                                {indexChoose === idx &&
                                    <div className="mt-4 flex justify-center">
                                        <span className="w-2 h-2 rounded-full bg-black" />
                                    </div>
                                }
                            </div>
                        ))}
                    </div>

                </div>

                <AnimatePresence>
                    <div ref={targetRef}></div>
                    <AIMobileComponent indexChoose={indexChoose} />
                </AnimatePresence>
            </div>
        </div>
    );
}
export default AI;